import { render } from "./EnvelopeAddressPreview.vue?vue&type=template&id=3ac10410"
import script from "./EnvelopeAddressPreview.vue?vue&type=script&lang=js"
export * from "./EnvelopeAddressPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__